import React, { useCallback } from 'react';
import { Keyboard } from 'react-native';
import Modal from 'utils/packages/Modal';
import useShouldShowUpgrade from 'features/premium/hooks/useShouldShowUpgrade';
import EditBudgetsCategoryModalContent from '../components/EditBudgetsCategoryModalContent';
import { isWeb } from '../../../constants';
export const useEditBudgetsCategoryModal = ({ onKeep, onEdit, category, isExplainZeroBudget, title, customIcon, }) => {
    const { rollingAccumulatedLimit } = category || {};
    const { isUnlockedForSpace } = useShouldShowUpgrade({
        benefitId: 'rollingBudgets',
    });
    return useCallback(() => {
        if (!category)
            return;
        Keyboard.dismiss();
        const isNegativeRollover = typeof rollingAccumulatedLimit === 'number' &&
            rollingAccumulatedLimit < 0;
        const confirmLabel = isNegativeRollover
            ? `Let me edit`
            : `Got it, let’s edit`;
        const cancelLabel = isNegativeRollover ? `Got it, let’s keep` : undefined;
        const explainZeroBudget = isExplainZeroBudget ??
            (!!isNegativeRollover && (category.totalLimit || 0) <= 0);
        const modalTitle = title ??
            (explainZeroBudget
                ? `Why ${category?.displayName ? `${category.displayName} ` : ''}budget is 0?`
                : 'Edit rolled budget');
        if (isWeb) {
            Modal.show(<EditBudgetsCategoryModalContent category={category} showSubDescription={!isUnlockedForSpace ? false : !!isNegativeRollover} explainZeroBudget={!isUnlockedForSpace ? false : explainZeroBudget} confirmLabel={confirmLabel} cancelLabel={cancelLabel} confirmHandler={() => {
                    onEdit();
                    Modal.hide();
                }} cancelHandler={isNegativeRollover
                    ? () => {
                        onKeep?.();
                        Modal.hide();
                    }
                    : undefined} customIcon={customIcon}/>, {
                title: modalTitle,
            });
        }
        else {
            Modal.showConfirmation({
                title: modalTitle,
                subtitle: (<EditBudgetsCategoryModalContent category={category} showSubDescription={!!isNegativeRollover} explainZeroBudget={explainZeroBudget} customIcon={customIcon}/>),
                confirmButtonTitle: confirmLabel,
                cancelButtonTitle: cancelLabel,
                onConfirm: () => {
                    onEdit();
                    Modal.hide();
                },
                onPressCancel: isNegativeRollover
                    ? () => {
                        onKeep?.();
                        Modal.hide();
                    }
                    : undefined,
            });
        }
    }, [
        category,
        isExplainZeroBudget,
        onEdit,
        onKeep,
        rollingAccumulatedLimit,
        title,
    ]);
};
